// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRollbackOutlinedSvg from "@fishx/icons-svg/es/asn/PRollbackOutlined";
import FishxIcon from '../components/FishxIcon';

var PRollbackOutlined = function PRollbackOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRollbackOutlinedSvg
  }));
};

PRollbackOutlined.displayName = 'PRollbackOutlined';
export default React.forwardRef(PRollbackOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRollbackOutlined.js
// module id = 3608
// module chunks = 0